import React from "react";
import styles from "./AiIntiativeCard.module.scss";
import AiInitiativeCard from "./AiInitiativeCard";

const AiCardList = () => {
  const list1: Array<string> = [
    "5+ Million eTail records",
    "50+ popular domains",
    "Social commerce data sets",
    "10+ Million Review data sets",
    "Price Comaprison data sets",
    "Brand data sets",
    "5000+ CPG data sets",
  ];
  const list2: Array<string> = [
    "On-demand data",
    "Bulk request handling",
    "Scalable scraping",
    "Single endpoint",
    "Monthly refreshes",
    "Manual & Automated Triggers",
    "Task Monitoring",
  ];
  const list3: Array<string> = [
    "Browser fingerprinting",
    "Automated unblocking",
    "IP rotations and retries",
    "CAPTCHA solving",
    "Social scrappers",
    "Activity logging",
    "Scrapping trackers",
  ];
  const list4: Array<string> = [
    "Residential IPs",
    "Shared and dedicated",
    "APIs for geo-targeting",
    "Unlimited bandwidth",
    "IP rotations",
  ];

  const data = [
    {
      image: "/Dataset.svg",
      heading: "Datasets",
      subheading: "Clean and validated pre-collected datasets.",
      list: list1,
      price: "$300/mo",
    },
    {
      image: "/web_scraper_api.svg",
      heading: "Scraper APIs",
      subheading: "Dedicated endpoints for top domains.",
      list: list2,
      price: "$0.001/record",
    },
    {
      image: "/Unblocking_Tech_2.svg",
      heading: "Data Scraping",
      subheading: "Simplify your data collection and optimize performance.",
      list: list3,
      price: "$3/GB",
    },
    {
      image: "/Residential-proxies.svg",
      heading: "Available proxies",
      subheading: "High-speed, reliable proxies for web scraping.",
      list: list4,
      price: "$0.9/IP",
    },
  ];

  return (
    <div className={styles["ai-cardlist-wrapper"]}>
      <h2>Accelerate your eTail initiatives</h2>
      <p>
        From on-demand, ethically sourced data to a dependable data scraping
        infrastructure.
      </p>
      <div className={styles["ai-cardlist"]}>
        {data.map((item, index) => (
          <AiInitiativeCard
            key={index}
            image={item.image}
            heading={item.heading}
            subHeading={item.subheading}
            list={item.list}
            price={item.price}
          />
        ))}
      </div>
    </div>
  );
};

export default AiCardList;
